var $ = jQuery.noConflict();

$(document).ready(function(){

    var accept_cookies = Cookies.get('accept-cookies');
    if(!accept_cookies){
        $('.ge-cookies').css('display', 'block');
    }

    $('.ge-cookies .ge-button-wrapper').click(function(){
        set_accept_cookies();
        $('.ge-cookies').animate({
            opacity: 0,
        }, 200, function() {
            $('.ge-cookies').css('display', 'none');
        });
    });

});

set_accept_cookies = function(){
    Cookies.set('accept-cookies', 1);
}




// WEBPACK FOOTER //
// ./assets/js/cookies.js